import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectSelectedEntityId } from 'app/store/projects';
import { selectCurrentFqn, selectCurrentTab } from 'app/store/findDatasets';
import { selectEntityByPropId } from 'app/store/entities';
import { selectWorkbenchDatasetTabForEntityId } from 'app/store/preferences';
import { doSelectTab } from 'app/store/findDatasets/actions.js';
import { doSelectWorkbenchDatasetTab } from 'app/store/preferences/actions';
import { doSelectTab as doSelectUsageReportingTab } from 'app/store/usageReporting/actions.js';
import { selectCurrentTab as selectCurrentUsageReportingTab } from 'app/store/usageReporting/selectors.js';
import { ExploreDataNotification } from './ExploreDataNotification.jsx';

const mapStateToProps = createStructuredSelector({
    entity: selectEntityByPropId,
    selectedWorkbenchDatasetQueryUuid: selectWorkbenchDatasetTabForEntityId,
    selectedEntityId: selectSelectedEntityId,
    currentFqn: selectCurrentFqn,
    currentTab: selectCurrentTab,
    currentUsageReportingTab: selectCurrentUsageReportingTab
});
const mapDispatchToProp = {
    onSelectDatasetTab: doSelectTab,
    onSelectWorkbenchDatasetTab: doSelectWorkbenchDatasetTab,
    onSelectUsageReportingTab: doSelectUsageReportingTab
};

export const ExploreDataNotificationContainer = connect(
    mapStateToProps,
    mapDispatchToProp
)(ExploreDataNotification);
